export default __webpack_public_path__ + "img/TourStep4.png";